import React, { ReactNode, useReducer } from "react";

import { json2normalized } from "fixtures/helper";

import CatalogReducer from "./CatalogStoreReducer";
import { TCatalog } from "types";
import { ConfigurationStore } from "stores";

type TCatalogProvider = {
  children: ReactNode;
};

const emptyCatalogStore: TCatalog = {
  entities: {},
  result: {},
};

export const CatalogStore = React.createContext<{
  state: TCatalog;
  dispatch: React.Dispatch<any>;
}>({
  state: emptyCatalogStore,
  dispatch: () => null,
});

const CatalogStoreProvider = ({ children }: TCatalogProvider) => {
  const [state, dispatch] = useReducer(CatalogReducer, emptyCatalogStore);

  const configuration = React.useContext(ConfigurationStore);

  React.useEffect(() => {
    getData(configuration.showroomId)(dispatch);
  }, [configuration]);

  return (
    <CatalogStore.Provider value={{ state, dispatch }}>
      {children}
    </CatalogStore.Provider>
  );
};

export const getData =
  (showroomId?: string): any =>
  async (dispatch: any) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/inventory/${showroomId || process.env.REACT_APP_SHOP_ID}`,
    );
    let data = await response.json();
    if (data.hasOwnProperty("vehicles") && !data.hasOwnProperty("vehicle")) {
      data = { ...data, vehicle: data.vehicles };
      delete data.vehicles;
    }

    data.vehicle = data.vehicle.filter(
      (vehicle: any) =>
        !!vehicle.modell &&
        !!vehicle.kraftstoff &&
        !!vehicle.aufbau_bereich &&
        !!vehicle.farbe_aussen &&
        !!vehicle.fzart,
    );

    const normalizedData = json2normalized(data);
    dispatch({ type: "INIT", payload: normalizedData });
  };

export default CatalogStoreProvider;
